import { Box, Flex, Group, Paper, ScrollArea, Switch, Text } from "@mantine/core";
import React from "react";
import ValidationTableSettings from "./ValidationTableSettings";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setShowContainerSpacesInRedux } from "../designSlice";

export const DesignSettings: React.FC = () => {
  const dispatch = useAppDispatch();
  const showContainerSpaces = useAppSelector((state) => state.design.showContainerSpaces);

  return (
    // Viktigt: minHeight: 0 gör att barnet får krympa och kan scrolla
    <Flex direction="column" h="100%" style={{ minHeight: 0 }}>
      <ScrollArea h="100%" style={{ flex: 1, minHeight: 0 }} type="auto" scrollbarSize={8}>
        <Box pr="xs" pb="md">
          <Text fw={700} size="lg" mb="xs">
            Innstillinger
          </Text>

          <Paper withBorder radius="md" p="md" mb="md" bg="white">
            <Group justify="space-between" gap="md" wrap="nowrap">
              <Box>
                <Text fw={600} size="sm">
                  Vis store overlappende spaces
                </Text>
                <Text size="xs" c="dimmed" mt={2}>
                  Slå på for å feilsøke filtrerte container-spaces.
                </Text>
              </Box>
              <Switch
                checked={showContainerSpaces}
                onChange={(event) =>
                  dispatch(setShowContainerSpacesInRedux(event.currentTarget.checked))
                }
                size="md"
              />
            </Group>
          </Paper>

          <ValidationTableSettings />
        </Box>
      </ScrollArea>
    </Flex>
  );
};
